
export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

export const getPeriodLabel = (range, offset) => {
    if (offset === 0) return range;
    if (offset === -1) {
        if (range === 'This Week') return 'Last Week';
        if (range === 'This Month') return 'Last Month';
        if (range === 'This Year') return 'Last Year';
    }
    const abs = Math.abs(offset);
    if (range === 'This Week') return `${abs} Weeks Ago`;
    if (range === 'This Month') return `${abs} Months Ago`;
    if (range === 'This Year') return `${abs} Years Ago`;
    return range;
};

export const getCountdown = (timeString) => {
    if (timeString === null || timeString === '--:--') {
        return '--:--';
    }
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;

    if (totalSeconds > 0) {
        const newSeconds = totalSeconds - 1;
        const newHours = Math.floor(newSeconds / 3600);
        const newMinutes = Math.floor((newSeconds % 3600) / 60);
        const remainingSeconds = newSeconds % 60;

        return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }
    return '00:00:00';
};

export const formatDateAU = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString('en-AU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Australia/Sydney'
    });
};

export const formatDateOnlyAU = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-AU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'Australia/Sydney'
    });
};

export const formatRemainingTime = (minutes) => {
    const mins = Math.floor(minutes);
    const secs = Math.floor((minutes % 1) * 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};
